import React from 'react';
import { Box, Paper, Stack, Typography } from '@mui/material';
import { BieTornadoRow } from './types';
import { formatMoney } from './format';

type Props = {
  rows: BieTornadoRow[];
};

const TornadoPanel: React.FC<Props> = ({ rows }) => {
  const top = [...rows].sort((a, b) => Math.abs(b.impactvalue) - Math.abs(a.impactvalue)).slice(0, 12);
  const max = Math.max(...top.map((r) => Math.abs(Number(r.impactvalue || 0))), 1);

  return (
    <Paper elevation={1} sx={{ p: 2 }}>
      <Typography variant="h6" sx={{ mb: 2 }}>Sensitivity Tornado</Typography>
      <Stack spacing={1.2}>
        {top.map((row) => {
          const impact = Number(row.impactvalue || 0);
          const width = Math.max(8, Math.min(100, (Math.abs(impact) / max) * 100));
          return (
            <Stack key={row.drivercode} direction="row" spacing={2} alignItems="center">
              <Typography sx={{ width: 190 }} variant="body2">{row.drivername}</Typography>
              <Box sx={{ flex: 1, height: 22, borderRadius: 1, bgcolor: 'action.hover', overflow: 'hidden' }}>
                <Box sx={{ width: `${width}%`, height: '100%', bgcolor: impact < 0 ? 'error.light' : 'primary.light' }} />
              </Box>
              <Typography sx={{ width: 120 }} align="right" variant="body2">
                {formatMoney(impact)}
              </Typography>
            </Stack>
          );
        })}
      </Stack>
    </Paper>
  );
};

export default TornadoPanel;
